import type { ReactNode } from "react";

import ResumenSection from "./sections/ResumenSection";
import MaintenanceListSection from "./sections/MaintenanceListSection";
import SeguimientoSection from "./sections/SeguimientoSection";
import HistorialSection from "./sections/HistorialSection";
import AgendaSection from "./sections/AgendaSection";
import CatalogoSection from "./sections/CatalogoSection";
import TalleresSection from "./sections/TalleresSection";
import ReportesSection from "./sections/ReportesSection";
import { MANTENIMIENTO_BASE } from "./paths";

// ---------------------------------------------------------------------------
// Single source of truth for the Mantenimiento a Vehículos navigation. Drives:
//   - the per-section sub-menu (MantenimientoLayout)
//   - the nested routes (router/config.tsx via routes.tsx)
//   - the apps-sidebar tile (AppsSidebar/appsConfig.tsx)
// Labels are i18n keys resolved at render time in the layout.
// ---------------------------------------------------------------------------

export interface MaintenanceNavItem {
  id: string; // route segment under /mantenimiento
  labelKey: string; // common-namespace i18n key
  icon: string; // remixicon class for the sub-menu
  element: ReactNode;
}

export const MENU: MaintenanceNavItem[] = [
  {
    id: "resumen",
    labelKey: "mantenimiento.menu.resumen",
    icon: "ri-dashboard-line",
    element: <ResumenSection />,
  },
  {
    id: "programado",
    labelKey: "mantenimiento.menu.programado",
    icon: "ri-calendar-schedule-line",
    element: <MaintenanceListSection type="programado" icon="ri-calendar-schedule-line" />,
  },
  {
    id: "solicitado",
    labelKey: "mantenimiento.menu.solicitado",
    icon: "ri-hand-heart-line",
    element: <MaintenanceListSection type="solicitado" icon="ri-hand-heart-line" />,
  },
  {
    id: "sugerido",
    labelKey: "mantenimiento.menu.sugerido",
    icon: "ri-lightbulb-flash-line",
    element: <MaintenanceListSection type="sugerido" icon="ri-lightbulb-flash-line" />,
  },
  {
    id: "ordenes",
    labelKey: "mantenimiento.menu.ordenes",
    icon: "ri-file-list-3-line",
    element: <MaintenanceListSection icon="ri-file-list-3-line" workOrders />,
  },
  {
    id: "seguimiento",
    labelKey: "mantenimiento.menu.seguimiento",
    icon: "ri-radar-line",
    element: <SeguimientoSection />,
  },
  {
    id: "historial",
    labelKey: "mantenimiento.menu.historial",
    icon: "ri-history-line",
    element: <HistorialSection />,
  },
  {
    id: "agenda",
    labelKey: "mantenimiento.menu.agenda",
    icon: "ri-calendar-check-line",
    element: <AgendaSection />,
  },
  {
    id: "talleres",
    labelKey: "mantenimiento.menu.talleres",
    icon: "ri-tools-line",
    element: <TalleresSection />,
  },
  {
    id: "catalogo",
    labelKey: "mantenimiento.menu.catalogo",
    icon: "ri-price-tag-3-line",
    element: <CatalogoSection />,
  },
  {
    id: "reportes",
    labelKey: "mantenimiento.menu.reportes",
    icon: "ri-bar-chart-box-line",
    element: <ReportesSection />,
  },
];

export { MANTENIMIENTO_BASE };

/** Default landing route (overview). */
export const mantenimientoDefaultRoute = `${MANTENIMIENTO_BASE}/${MENU[0].id}`;

/** apps-sidebar tile metadata. */
export const mantenimientoApp = {
  id: "mantenimiento-vehiculos",
  iconClass: "ri-tools-line",
  color: "bg-orange-500",
  route: mantenimientoDefaultRoute,
};
